import * as React from 'react';
import { Input } from 'antd';

interface CommaSeparatedInputProps {
    onChange?: (values: string[]) => void;
    placeholder?: string;
    [key: string]: any;
}

export function CommaSeparatedInput({ 
    onChange, 
    placeholder,
    ...rest 
}: CommaSeparatedInputProps): React.ReactElement {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value;
        const values = inputValue
            .split(',')
            .map(item => item.trim())
            .filter(item => item.length > 0);
        
        if (onChange) {
            onChange(values);
        }
    };

    return (
        <Input
            onChange={handleChange}
            placeholder={placeholder}
            {...rest}
        />
    );
}

